import React, { useMemo, useRef } from 'react';
import { Layout } from 'tea-component';
import MemeInfo from './component/MemeInfo';
import CardLoading from '@op/components/CardLoading';
import { useFilterFromShortId } from '@opm/utils/history';
import { useMemeDetails } from '@opm/pages/Memes/hooks';
import useIntls from '@opm/hooks/useIntls';
import MemeDataSection from './component/MemeDataSection';
import { MemesDetailsPoint } from '@opm/operationLog/pages';
import { DBOM_POINT } from '@opm/operationLog/buriedPoint';
import './index.scss';

const { Content } = Layout;

const MemeDetails = () => {
  DBOM_POINT.useInitPage({ buriedPoint: MemesDetailsPoint });
  const { intl } = useIntls();
  const { filter, loading } = useFilterFromShortId();

  const wholePageRef = useRef<HTMLDivElement>(null);
  const filterParams = useMemo(() => {
    if (!filter) return {};

    const {
      meme_id: memeId,
      total_likes: likes,
      total_views: views,
      meme_elements: elements,
      meme_types: types,
      ...restFilter
    } = filter;

    return {
      ...restFilter,
      meme_title: memeId,
    };
  }, [filter]);

  const { data: memeData, loading: memeLoading } = useMemeDetails({
    filter: filterParams,
  });


  return (
    <Content className="dbom-meme-details" ref={wholePageRef}>
      <CardLoading loading={loading}>
        <Content.Header
          title={intl('Meme Details')}
          showBackButton
          onBackButtonClick={() => {
            window.history.back();
          }}
        />
        <Content.Body full>
          <MemeInfo data={memeData} loading={memeLoading} />
          <MemeDataSection
            loading={memeLoading}
            empty={!memeData || Object.keys(memeData).length === 0}
            filter={filterParams}
            startOfTime={memeData.min_release_time}
            endOfTime={memeData.max_release_time}
            wholePageRef={wholePageRef}
          />
        </Content.Body>
      </CardLoading>
    </Content>
  );
};

export default MemeDetails;
